(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-gallery-case"]) return;
  try {
    
document.querySelectorAll('.gallery-case__thumb').forEach(function (btn) {
  btn.addEventListener('click', function () {
    var main = document.getElementById('gallery-case-main-img');
    if (!main) return;
    main.src = btn.dataset.src;
    main.removeAttribute('srcset');
    document.querySelectorAll('.gallery-case__thumb').forEach(function (b) { b.classList.remove('is-active'); });
    btn.classList.add('is-active');
  });
});

  } catch(e) { console.error(e); }
})();
})();
